import {Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-frameboard-fedatario',
  templateUrl: './frameboard-fedatario.component.html',
  styleUrls: ['./frameboard-fedatario.component.scss']
})
export class FrameboardFedatarioComponent implements OnInit {
    @Input() GeneralSearchActive = false

    link = {
        'listar-solicitudes': false,
        'solicitudes-atendidas': false,
        'solicitudes-entregadas': false,
        'solicitudes-reasignadas': false,
        'solicitudes-canceladas': false,
        'reportes': false
    }
  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
        this.document.location.href.split('/').forEach(l => {
            this.link[l] = true
        })
  }
    activateLink(link: string) {
        Object.keys(this.link).forEach(key => {
            this.link[key] = false
        })
        this.link[link] = true
    }
}
